export const TRAINING_DATA = {
    data: [
        [1, 350, "apartment"],
        [2, 300, "apartment"],
        [3, 300, "apartment"],
        [4, 250, "apartment"],
        [4, 500, "apartment"],
        [4, 400, "apartment"],
        [5, 450, "apartment"],
        [7, 850, "house"],
        [7, 900, "house"],
        [7, 1200, "house"],
        [8, 1500, "house"],
        [9, 1300, "house"],
        [8, 1240, "house"],
        [10, 1700, "house"],
        [9, 1000, "house"],
        [1, 800, "loft"],
        [3, 900, "loft"],
        [2, 700, "loft"],
        [1, 900, "loft"],
        [2, 1150, "loft"],
        [1, 1000, "loft"],
        [2, 1200, "loft"],
        [1, 1300, "loft"]
    ],
    dimensions: ["rooms", "area", "type"]
};



// WEBPACK FOOTER //
// ./src/knn/training-data.js